export default __webpack_public_path__ + "static/media/Rectangle 516.aaa37754.png";